import { Schema } from 'effect';

// Shared smoke-check item schema used by the P1 sandbox smoke response and
// the P9 production smoke run response. Both endpoints return an array of
// these items; centralising the schema avoids repeating the four-field shape.
export const smokeCheckItemSchema = Schema.Struct({
  id: Schema.NonEmptyString,
  label: Schema.NonEmptyString,
  passed: Schema.Boolean,
  detail: Schema.NonEmptyString,
}).annotate({
  title: 'Power onboarding smoke check item',
  description:
    'Shared smoke-check result item used by P1 sandbox and P9 production smoke responses.',
});
